import { render } from "./open-cert.vue?vue&type=template&id=12cbc663&scoped=true"
import script from "./open-cert.vue?vue&type=script&lang=js"
export * from "./open-cert.vue?vue&type=script&lang=js"

import "./open-cert.vue?vue&type=style&index=0&id=12cbc663&lang=less&scoped=true"

import exportComponent from "/root/project/msp-fronted/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12cbc663"]])

export default __exports__